import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const pricingUpdateSlice = createApi({
    reducerPath: "pricingUpdate",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        pricingUpdate: builder.mutation({
            query: ({ id, data }) => ({
                url: "/order-management/api/v1/productpricing/update?id=" + id,
                method: "PATCH",
                body: data,
            }),
        }),
    }),
});

export const { usePricingUpdateMutation } = pricingUpdateSlice;
